import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { urls } from '../../../urls'
import MainMenu from '../MainMenu/MainMenu'
import AppBarComponent from '../AppBar/AppBarComponent'
import { makeStyles, createStyles, Theme, useTheme } from '@material-ui/core/styles'
import { CssBaseline, useMediaQuery } from '@material-ui/core'
import ThirdForm from '../Third/ThirdForm'
import ThirdList from '../Third/ThirdList'
import ThirdMigration from '../Third/ThirdMigration'
import ItemForm from '../Item/ItemForm'
import ItemList from '../Item/ItemList'
import ElectronicBillForm from '../ElectronicBill/ElectronicBillForm'
import ProtectRoute from '../../ComponentsForProtectRoutes/ProtectRoute'
import ElectronicBillList from '../ElectronicBill/ElectronicBillList'
import ScheduledBillList from '../ElectronicBill/ScheduledBillsList'
import CreditNoteList from '../ElectronicBill/CreditNoteList'
import SupportDocumentForm from '../SupportDocument/SupportDocumentForm'
import SupportDocumentList from '../SupportDocument/SupportDocumentList'
import CreditNoteSupportDocumentList from '../SupportDocument/CreditNoteSupportDocumentList'
import PlanStatusModal from '../PlanStatus/PlanStatusModal'
import PlanStatusBanner from '../PlanStatus/PlanStatusBanner'

// -------------- Styles --------------
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // Contenedor raíz: fila flex, altura completa del viewport, sin scroll propio
    // (100dvh evita que la barra del navegador móvil recorte el contenido)
    root: {
      display: 'flex',
      height: '100vh',
      overflow: 'hidden',
      background: '#fafafa',
      '@supports (height: 100dvh)': {
        height: '100dvh',
      },
    },
    // Área de contenido: ocupa el resto del ancho, scroll vertical propio.
    // minWidth: 0 evita que contenido ancho (tablas) empuje el layout horizontalmente.
    main: {
      flex: 1,
      minWidth: 0,
      height: '100%',
      overflowY: 'auto',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
  }),
)

export default function ContainerApp() {
  const classes = useStyles()
  const theme = useTheme()
  // xs (<600): menú como drawer temporal con botón hamburguesa
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  // sm (600-959): menú como rail de iconos
  const isRail = useMediaQuery(theme.breakpoints.between('sm', 'sm'))
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)

  // al pasar de mobile a otra resolución el drawer temporal debe quedar cerrado
  React.useEffect(() => {
    if (!isMobile) setMobileMenuOpen(false)
  }, [isMobile])

  return (
    <div className={classes.root}>
      <CssBaseline />

      <MainMenu
        variant={isMobile ? 'temporary' : 'permanent'}
        collapsed={isRail}
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      />

      <main className={classes.main}>
        <AppBarComponent
          showMenuButton={isMobile}
          onMenuClick={() => setMobileMenuOpen(true)}
        />
        <PlanStatusBanner />
        <Routes>
            <Route path={urls.app.main.third.form} element={
              <ProtectRoute>
                <ThirdForm />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.third.list} element={
              <ProtectRoute>
                <ThirdList />
              </ProtectRoute>
            }/>
              
            <Route path={urls.app.main.third.thirdMigrationForm} element={
              <ProtectRoute>
                <ThirdMigration />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.item.form} element={
              <ProtectRoute>
                <ItemForm />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.item.list} element={
              <ProtectRoute>
                <ItemList />
              </ProtectRoute>
            }/>
              
            <Route path={urls.app.main.electronicBill.form} element={
              <ProtectRoute>
                <ElectronicBillForm />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.supportDocument.form} element={
              <ProtectRoute>
                <SupportDocumentForm />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.supportDocument.list} element={
              <ProtectRoute>
                <SupportDocumentList />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.supportDocument.credit_note_list} element={
              <ProtectRoute>
                <CreditNoteSupportDocumentList />
              </ProtectRoute>
            }/>
            
            <Route path={urls.app.main.electronicBill.list} element={
              <ProtectRoute>
                <ElectronicBillList />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.electronicBill.schedule_list} element={
              <ProtectRoute>
                <ScheduledBillList />
              </ProtectRoute>
            }/>

            <Route path={urls.app.main.electronicBill.credit_note_list} element={
              <ProtectRoute>
                <CreditNoteList />
              </ProtectRoute>
            }/>
        </Routes>
      </main>

      {/* Plan status modals */}
      <PlanStatusModal />
    </div>
  )
}
